import { useLanguage } from "@/contexts/language-context"
import { translations, type TranslationKey } from "@/translations"

export function useTranslation() {
  const { language } = useLanguage()

  const t = (key: TranslationKey, vars?: Record<string, string | number>): string => {
    let str = translations[language][key]
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replace(new RegExp(`{${k}}`, "g"), String(v))
      })
    }
    return str
  }

  return { t, language }
}
